
class ValidateController {
    /*@ngInject*/
    constructor($stateParams, $scope, $state, $interval, orderStore, auth, utils, $q) {
        "ngInject";
        _.extend(this, {
            $stateParams: $stateParams,
            $state: $state,
            $scope:$scope,
            orderStore: orderStore,
            $interval: $interval,
            auth: auth,
            utils: utils,
            $q: $q
        });
        $scope.tpinBtnHide = true;
        $scope.conutdownTexthide = false;

        var decreamentCountdown=function()
        {
            $scope.tpinBtnHide = true;
            $scope.conutdownTexthide = false;

            $scope.countdown -=1;
            if($scope.countdown<1)
            {
                $scope.tpinBtnHide = false;
                $scope.conutdownTexthide = true;


            }
        };
        $scope.startCountDown=function()
        {
            $interval(decreamentCountdown,1000,$scope.countdown)
        };
        $scope.countdown=15;
        $scope.startCountDown();

        this.userNumber = this.utils.getURLParameterByName('number');

        this.censoredNumber = this.censorNumber(this.userNumber);

        this.orderLoader = this.auth.createUser({ phone_number: this.userNumber }, false)
            .then(
                (response) => {
                    this.user = response;
                    this.auth.setCurrentUser(this.user)
                },
                (error) => console.log(error)
            )
    }

    requestTPin() {
        this.$scope.countdown = 15;
        this.$scope.startCountDown();
        let user = this.auth.currentUser();
        this.$scope.tpinBtnHide = true;
        this.$scope.conutdownTexthide = false;

        this.loader = this.auth.createUser(user)
            .then(
                (user) => {},
                (error) => alert(error.message)
            );
    }
    enterKey(keyEvent, tpin) {
        if (keyEvent.which == 13 || keyEvent.keyCode == 13) {
            this.confirmTPin(tpin);
        }
    }
    confirmTPin(tpin) {
        this.orderLoader = this.auth.login(parseInt(tpin, 10), this.userNumber)
            .then(
                (user) => this.next(),
                (error) => {
                    console.log(error.data);
                    alert("Invalid Tpin!");
                }
            );
    }

    next() {
        this.$state.go('base.basic-traffic', {orderId: 'new', traffic: 'campaign_page'});
    }

    censorNumber(number) {
        return number[0] + number[1] + 'xxxxxxx' + number[number.length - 1];
    }

}


export default ValidateController;


// WEBPACK FOOTER //
// ./client/app/components/validate/validate.controller.js